<!-- cv-confirmation.component.html -->
<div *ngIf="isVisible" class="notify-popup-bg">
  <div class="notify-popup">
     <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
    <h2>{{ title }}</h2>
    <p>{{ msg }}</p>
    <div class="notify-popup__btns">
      <div class="is-btn is-btn__outfill"  (click)="cancel()">{{ cancelLabel }}</div>
    <div class="is-btn" (click)="confirm()">{{ okLabel }}</div>
    </div>
  </div>
</div>
